import styled from 'styled-components';
import { colors } from '@custom-components';

export const ChipBar = styled.div`
  width: 100%;
  background-color: ${colors.colorGrey04};
  padding: 0 19px;
`;
